import angular from 'angular';
import uiRouter from 'angular-ui-router';
import commentsComponent from './comments.component';

let commentsModule = angular.module('comments', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.comments', {
    url: '/comments',
    component: 'comments'
  });
})

.component('comments', commentsComponent)

.name;

export default commentsModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/comments/comments.js